import axios from 'axios'
import { makeUseAxios } from 'axios-hooks'
import { getDsnInstance } from '@demo-system/commons/service/dsn'
import { ACCESS_TOKEN, API_V1, API_V2, API_PROJECTS } from './environment'

function createV2Instance(baseURL) {
  let config = ACCESS_TOKEN
    ? {
        headers: {
          'x-access-token': ACCESS_TOKEN,
          'Access-Control-Allow-Origin': '*',
          'x-origin-id': window.DSN.originId,
        },
      }
    : {
        credentials: 'include',
        headers: {
          'x-origin-id': window.DSN.originId,
        },
      }

  return axios.create({
    baseURL,
    withCredentials: !!config.credentials,
    timeout: 15000,
    headers: config.headers,
  })
}

export const dsnApiV1 = getDsnInstance({
  accessToken: ACCESS_TOKEN,
  apiUrl: API_V1,
})

export const dsnApiV2 = createV2Instance(API_V2)
export const dsnProjectApi = createV2Instance(API_PROJECTS)

export const useDsnApiV1 = makeUseAxios({ axios: dsnApiV1 })
export const useDsnApiV2 = makeUseAxios({ axios: dsnApiV2 })
export const fetch = (fetchingFunction, params) => fetchingFunction(dsnApiV2, params)
